import React from "react";

// Local
import { BoxRowFlow } from "../../styled/styled";
import Org from "./Org";

const OrganizationTab = ({ organizations, actions, state }) => {
  return (
    <BoxRowFlow>
      {organizations.sort().map((org, i) => (
        <Org key={`org${i}`} orgCode={org} actions={actions} state={state} />
      ))}
    </BoxRowFlow>
  );
};

export default OrganizationTab;
